<template>
    <v-card class="text_background">
      <v-card-title class="background--text">
        {{ $t("settings.language") }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-radio-group v-model="componentLang">
          <v-radio
            color="primary"
            v-for="(lang, i) in languages"
            :key="i + lang.code"
            :value="lang"
            return-object
          >
            <template v-slot:label>
              <div class="d-flex flex-column jutify-start background--text">
                <span class="">{{ lang.engName }}</span>
                <span class="caption">{{ lang.name }}</span>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <button class="ml-auto background--text" @click="closeDialog">
          {{ $t("general.cancel") }}
        </button>
        <button class="button ml-5" @click="changeLang">
          {{ $t("general.save") }}
        </button>
      </v-card-actions>
    </v-card>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      tempLang: null,
    };
  },

  computed: {
    ...mapState({
      language: (state) => state.base.mobileLang,
      languages: (state) => state.base.languages,
    }),

    componentLang: {
      get() {
        return this.language;
      },
      set(newValue) {
        this.tempLang = newValue;
      },
    },
  },

  methods: {
    ...mapMutations(["setMobileLang"]),

    changeLang() {
      if (this.tempLang != null) this.setMobileLang(this.tempLang);
      this.$i18n.locale = this.language.code;
      this.closeDialog();
    },

    closeDialog(){
      this.$emit('close') 
    }
  },
};
</script>

<style scoped lang="scss">
.button{
  background-color: var(--v-important-base);
  color: white;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 3px;
  border-radius: 20px;
}
</style>